<script lang="ts">
    import {Component, mixins, toNative} from 'vue-facing-decorator'
    import BookingPageBase from '~src/components/parts/bookingPageBase.src'
    import {VisaStoreMixin} from '@/mixins/VisaStoreMixin.vue'
    import {callComponentMethod} from '~/utils/vue-class-helpers'

    @Component({mixins: [BookingPageBase]})
    export class VisaBookingPageLayout extends mixins(VisaStoreMixin) {
        initTourists(sr, tourists) {
            const touristsList = callComponentMethod(this, BookingPageBase, 'initTourists', sr, tourists)
            return touristsList
        }

        // TODO [P5] Need refactoring and implement prepareBookRequest in adapter functions
        prepareBookRequest(specifiedTouristBookingFields, includeOptionalTourists = false) {
            const prepareBookRequest = callComponentMethod(
                this,
                BookingPageBase,
                'prepareBookRequest',
                specifiedTouristBookingFields,
                includeOptionalTourists
            )
            for (const tourist of prepareBookRequest.tourists) {
                delete tourist.passport
            }
            return prepareBookRequest
        }

        get productSearchPageName() {
            return 'visaSearch'
        }

        get productConfirmationPageName() {
            return 'visaConfirmation'
        }

        get productName() {
            return 'visa'
        }

        get productBookingPageName() {
            return 'visaBooking'
        }

        get corporatePolicyType() {
            return null
        }

        get touristToken() {
            return 'tourist'
        }
    }

    export default {...toNative(VisaBookingPageLayout), ssrRender: BookingPageBase.ssrRender}
</script>
